import React from "react"
import Skeleton from "../../components/Skeleton/Skeleton"

const SavingsPageSkeletonConfig = [
    {
        classes: "alignEnd",
        columns: [
            {
                classes: "marginTop-32",
                rows: [
                    { span: 8, height: "50px" },
                    { span: 16, height: "150px", classes: "marginTop-32" },
                ],
            },
            { span: 8, height: "200px", classes: "marginTop-32" },
        ],
    }, // Row 1
]

const useYourBenefitsSkeleton = [
    { span: 24, height: "48px", classes: "marginTop-48 justifyCenter" },
    {
        classes: "marginTop-48",
        columns: [
            { span: "8", height: "160px" },
            { span: "8", height: "160px" },
            { span: "8", height: "160px" },
        ],
    },
]

const partnershipOffersSkeleton = [
    {
        span: 24,
        height: "40px",
        classes: "marginTop-48",
    },
    {
        height: "227px",
        classes: "marginTop-16 spaceAround",
        columns: [
            {
                span: 8,
                height: "227px",
            },
            {
                span: 8,
                height: "227px",
            },
            {
                span: 8,
                height: "227px",
            },
        ],
    },
]

const benefitsListConfig = [
    { span: 24, height: "48px", classes: "marginTop-48 justifyCenter" },
    {
        classes: "marginTop-48",
        columns: [
            {
                height: "200px",
                span: 12,
            },
            {
                height: "200px",
                span: 12,
            },
        ],
    },
    { span: 24, height: "48px", classes: "marginTop-48 justifyCenter" },
    {
        classes: "marginTop-48",
        columns: [
            {
                height: "200px",
                span: 12,
            },
            {
                height: "200px",
                span: 12,
            },
        ],
    },
    { span: 24, height: "48px", classes: "marginTop-48 justifyCenter" },
    {
        classes: "marginTop-48",
        columns: [
            {
                height: "200px",
                span: 12,
            },
            {
                height: "200px",
                span: 12,
            },
        ],
    },
]
const pharmacyConfig = [
    { span: 24, height: "48px", classes: "marginTop-48 justifyCenter" },

    {
        classes: "marginTop-48",
        columns: [
            {
                height: "240px",
                span: 6,
            },
            {
                height: "240px",
                span: 6,
            },
            {
                height: "240px",
                span: 6,
            },
            {
                height: "240px",
                span: 6,
            },
        ],
    },
]

function SavingsSkeleton() {
    return (
        <div className="page-container">
            <Skeleton config={SavingsPageSkeletonConfig}></Skeleton>
            <Skeleton config={useYourBenefitsSkeleton}></Skeleton>
            <Skeleton config={partnershipOffersSkeleton}></Skeleton>
            <Skeleton config={pharmacyConfig}></Skeleton>
            <Skeleton config={benefitsListConfig}></Skeleton>
        </div>
    )
}

export default SavingsSkeleton
